import React from 'react';
import icon1 from './icon-1.svg'
import icon2 from './icon-2.svg'
import icon3 from './icon-3.svg'
import icon4 from './icon-4.svg'
import './info-block.scss';
import {useTranslation} from "react-i18next";

function InfoBlock() {
    const { t } = useTranslation()
    return <div id="about" className="info-block mt mb">

        <div className="info-block__top" data-aos="fade-down">
            <h2 className="info-block__title title">{t('info_block.title')}</h2>
            <span className="info-block__subtitle">{t('info_block.text')}</span>
        </div>

        <div className="info-block__items">

            <div className="info-block__item" data-aos="fade-down">

                <div className="info-block__item-icon">
                    <img src={icon1} alt=""/>
                </div>

                <span className="info-block__item-text">{t('info_block.i1')}</span>

            </div>

            <div className="divider" data-aos="fade-up"/>

            <div className="info-block__item" data-aos="fade-down">

                <div className="info-block__item-icon">
                    <img src={icon2} alt=""/>
                </div>

                <span className="info-block__item-text">{t('info_block.i2')}</span>

            </div>

            <div className="divider" data-aos="fade-up"/>

            <div className="info-block__item" data-aos="fade-down">

                <div className="info-block__item-icon">
                    <img src={icon3} alt=""/>
                </div>

                <span className="info-block__item-text">{t('info_block.i3')}</span>

            </div>

            <div className="divider" data-aos="fade-up"/>

            <div className="info-block__item" data-aos="fade-down">

                <div className="info-block__item-icon">
                    <img src={icon4} alt=""/>
                </div>

                <span className="info-block__item-text">{t('info_block.i4')}</span>

            </div>

        </div>

    </div>;
}

export default InfoBlock;